import { CgDollar } from 'react-icons/cg';

import { FormField, NumberInput } from '~/core/shared/components';
import { FieldProps } from '../DocumentField.component';

export const CurrencyField = (props: FieldProps<Resources.FormInputField>) => (
  <FormField
    component={NumberInput}
    decimalPlaces={2}
    startElement={<CgDollar />}
    {...props}
  />
);
